import { render, staticRenderFns } from "./ProductOrderItemDocumentPopUp.vue?vue&type=template&id=38c023a3&scoped=true&"
import script from "./ProductOrderItemDocumentPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderItemDocumentPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderItemDocumentPopUp.vue?vue&type=style&index=0&id=38c023a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c023a3",
  null
  
)

export default component.exports